import { Container } from 'inversify'
import { LotResolver } from '../Pipelines/LotResolver'
import { SERVICES as SERVICES_LOT } from '../../../Foundation/LotApi/serviceRegistration'
import {
  GetAuctionPagePropertiesType,
  SERVICES as SERVICES_AUCTIONS,
} from '../../../Foundation/Auctions/serviceRegistration'
import { LotPageDataExtender } from '../Pipelines/LotPageDataExtender'
import { LotService } from '../../../Foundation/LotApi/Services/LotService'

export const SERVICES = {
  LotPageUrlResolver: Symbol.for('LotPageUrlResolver'),
  LotDataExtender: Symbol.for('LotDataExtender'),
}

export function registerBinding(container: Container): void {
  container.bind<() => LotPageDataExtender>(SERVICES.LotDataExtender).toConstantValue(() => {
    const lotService = container.get<() => LotService>(SERVICES_LOT.LotService)()
    const getAuctionPageProperties = container.get<GetAuctionPagePropertiesType>(
      SERVICES_AUCTIONS.getAuctionPageProperties
    )
    return new LotPageDataExtender(lotService, getAuctionPageProperties)
  })

  container.bind<() => LotResolver>(SERVICES.LotPageUrlResolver).toConstantValue(() => {
    const lotService = container.get<() => LotService>(SERVICES_LOT.LotService)()
    return new LotResolver(lotService)
  })
}

//  DO NOT DELETE - used by DW
